import { IconAddBorder, IconStretch, IconAddBackground, IconPicture, IconUndo } from '@codexteam/icons';
import UI from "./ui";

export default class StoredImage {
  constructor({ data, config, api, block, readOnly }) {
    this.data = {
      caption: data.caption || "",
      withBorder: data.withBorder !== undefined ? data.withBorder : false,
      withBackground:
        data.withBackground !== undefined ? data.withBackground : false,
      stretched: data.stretched !== undefined ? data.stretched : false,
      file: {
        alias: data.file !== undefined ? data.file.alias : "",
        url: data.file !== undefined ? data.file.url : "",
      },
    };
    this.config = {
      actions: config.actions || [],
      apiUrl: config.apiUrl || "",
      additionalRequestHeaders: config.additionalRequestHeaders || {}
    };
    this.api = api;
    this.blockAPI = block;
    this.readOnly = readOnly;
    this.ui = new UI({
      data: this.data,
      api,
      blockAPI: block,
      config: this.config,
      readOnly,
      tunes: this.constructor.filledTunes
    })
  }

  static get toolbox() {
    return {
      title: "Image",
      icon: IconPicture
    };
  }

  static get status() {
    return {
      EMPTY: 'empty',
      FILLED: 'filled',
    };
  }

  static get filledTunes() {
    return [
      {
        name: "withBorder",
        icon: IconAddBorder,
        title: "With border",
        toggle: true,
      },
      {
        name: "stretched",
        icon: IconStretch,
        title: "Stretch image",
        toggle: true,
      },
      {
        name: "withBackground",
        icon: IconAddBackground,
        title: "With background",
        toggle: true,
      },
      {
        name: "clear",
        icon: IconUndo,
        title: "Clear",
        toggle: false,
      }
    ];
  }

  static get tunes() {
    return [];
  }

  render() {
    return this.ui.render(this.data);
  }

  renderSettings() {
    let tunes;
    if(this.data && this.data.file && this.data.file.url !== "") {
      tunes = this.constructor.filledTunes.concat(this.config.actions);
    } else {
      tunes = this.constructor.tunes.concat(this.config.actions);
    }
    return tunes.map((tune) => ({
      icon: tune.icon,
      label: this.api.i18n.t(tune.title),
      name: tune.name,
      toggle: tune.toggle,
      isActive: this.data[tune.name],
      onActivate: () => {
        /* If it's user defined tune, execute its callback stored in action property */
        if (typeof tune.action === "function") {
          tune.action(tune.name);
          return;
        }
        if (tune.name === "clear") {
          this.data = {
            caption: "",
            withBorder: false,
            withBackground: false,
            stretched: false,
            file: {
              alias: "",
              url: "",
            }
          }
          this.ui._reset(this.data)
          this.render();
          this.api.toolbar.close();
          // Set focus here
          this.ui.setFocus()
          return;
        }
        this.ui._toggleTune(tune.name);
      },
    }));
  }

  validate(savedData) {
    return savedData.file && savedData.file.url;
  }

  save(blockContent) {
    const caption = blockContent.querySelector("[contenteditable]");
    let captionText = ""
    if (caption.innerHTML === '<br>') {
      captionText = ""
    } else {
      captionText = caption.innerHTML;
    }
    return Object.assign(this.data, {
      caption: captionText || '',
    });
  }
}